// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Jy-z","tooltipWrapper":"Ky-z","icon":"Ly-z","tooltip":"My-z","content":"Ny-z"};